import { useState, useEffect } from "react";
import "./OfferForm.css";

export default function OfferForm({ offer, onClose, onSave, apiUrl, token }) {
    const [form, setForm] = useState({
        titleOffer: "",
        descriptionOffer: "",
        priceOfferHT: "",
        priceOfferTTC: "",
        vatRate: 20,
        durationDays: 30,
        isRecurring: false, // ✅ Nouveau champ
    });
    useEffect(() => {
        if (offer) {
            setForm({
                titleOffer: offer.titleOffer,
                descriptionOffer: offer.descriptionOffer,
                priceOfferHT: offer.priceOfferHT,
                priceOfferTTC: offer.priceOfferTTC,
                vatRate: offer.vatRate,
                durationDays: offer.durationDays,
                isRecurring: !!offer.isRecurring, // ✅ on convertit en booléen
            });
        }
    }, [offer]);

    const handleChange = (e) => {
        const { name, value, type } = e.target;

        setForm((prev) => {
            let updated = { ...prev, [name]: type === "checkbox" ? e.target.checked : value };

            // Calcul automatique HT/TTC
            const vatMultiplier = 1 + updated.vatRate / 100;
            if (name === "priceOfferHT") {
                updated.priceOfferTTC = (parseFloat(value) * vatMultiplier || 0).toFixed(2);
            } else if (name === "priceOfferTTC") {
                updated.priceOfferHT = (parseFloat(value) / vatMultiplier || 0).toFixed(2);
            } else if (name === "vatRate") {
                updated.priceOfferTTC = (parseFloat(updated.priceOfferHT) * (1 + parseFloat(value) / 100) || 0).toFixed(2);
            }

            return updated;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("titleOffer", form.titleOffer);
        formData.append("descriptionOffer", form.descriptionOffer);
        formData.append("durationDays", form.durationDays);
        formData.append("priceOfferHT", form.priceOfferHT);
        formData.append("priceOfferTTC", form.priceOfferTTC);
        formData.append("vatRate", form.vatRate);
        formData.append("isRecurring", form.isRecurring ? 1 : 0); // ✅ envoi en numérique (1/0)

        const isUpdate = !!offer;
        if (isUpdate) {
            formData.append("_method", "PUT");
        }

        try {
            const url = isUpdate
                ? `${apiUrl}/api/offers/${offer.idOffer}`
                : `${apiUrl}/api/offers`;

            const response = await fetch(url, {
                method: "POST",
                body: formData,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.error || "Erreur sauvegarde offre");

            alert(data.message || (isUpdate ? "Offre mise à jour" : "Offre créée"));
            onSave();
            onClose();
        } catch (err) {
            console.error(err);
            alert(err.message);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal">
                <h3>{offer ? "Modifier l'offre" : "Nouvelle offre"}</h3>
                <form onSubmit={handleSubmit}>
                    <label>
                        Titre :
                        <input
                            type="text"
                            name="titleOffer"
                            value={form.titleOffer}
                            onChange={handleChange}
                            required
                        />
                    </label>

                    <label>
                        Description :
                        <textarea
                            name="descriptionOffer"
                            value={form.descriptionOffer}
                            onChange={handleChange}
                            required
                        />
                    </label>

                    <label>
                        Prix HT (€) :
                        <input
                            type="number"
                            step="0.01"
                            name="priceOfferHT"
                            value={form.priceOfferHT}
                            onChange={handleChange}
                            required
                        />
                    </label>

                    <label>
                        Prix TTC (€) :
                        <input
                            type="number"
                            step="0.01"
                            name="priceOfferTTC"
                            value={form.priceOfferTTC}
                            onChange={handleChange}
                            required
                        />
                    </label>

                    <label>
                        Taux TVA (%) :
                        <input
                            type="number"
                            step="0.01"
                            name="vatRate"
                            value={form.vatRate}
                            onChange={handleChange}
                            required
                        />
                    </label>

                    <label>
                        Durée (jours) :
                        <input
                            type="number"
                            name="durationDays"
                            value={form.durationDays}
                            onChange={handleChange}
                            required
                        />
                    </label>

                    {/* ✅ Nouveau champ pour abonnement */}
                    <label className="checkbox">
                        <input
                            type="checkbox"
                            name="isRecurring"
                            checked={form.isRecurring}
                            onChange={handleChange}
                        />
                        Offre avec abonnement (récurrente)
                    </label>

                    <div className="modal-actions">
                        <button type="submit" className="btn-save">Enregistrer</button>
                        <button type="button" className="btn-cancel" onClick={onClose}>
                            Annuler
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
